import React, { useEffect, useState } from "react"
import _ from "lodash"
import { useSelector, useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { Tooltip, Select, FormControl, MenuItem, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { KeyboardArrowDown } from "@material-ui/icons"
import { updateFileTag, updateFileTagReset } from "../../actions/documentsActions"
import { requestCustomTags } from "../../../src/actions/customTagsActions"

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 150,
	},
	selectEmpty: {
		marginTop: theme.spacing(1),
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-end",
		padding: "2px",
		gap: "2px",
		maxWidth: "150px",
		height: "30px",
		borderRadius: "3px",
		fontSize: "14px",
		"& .MuiSelect-icon": {
			color: "#475163",
		},
		"& .MuiInput-input": {
			padding: "4px",
		},
	},
	menuItemStyle: {
		marginTop: theme.spacing(1),
	},
}))

export default function TagSelect(props) {
	const classes = useStyles()
	const [t] = useTranslation("global")
	const dispatch = useDispatch()

	const [selectedTag, setSelectedTag] = useState(props?.fileData?.currTag?.[0] || "")

	const { tags } = useSelector((state) => state.tags.custom_tags)
	const { isApplyTagLoading, isApplyTagSuccess } = useSelector((state) => state.search)
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)

	const handleChange = (event) => {
		if (event.target.value) {
			if (event.target.value === "remove") {
				if (props?.fileData?.id && selectedTag) {
					dispatch(updateFileTag({ document_id: props?.fileData?.id, tag_id: selectedTag, type: event.target.value }))
					setTimeout(() => {
						setSelectedTag("")
					}, 1000)
				}
			} else {
				dispatch(updateFileTag({ document_id: props?.fileData?.id, tag_id: event.target.value, type: "update" }))
				setSelectedTag(event.target.value)
			}
		}
	}

	const getTagColor = (tagId, alpha) => {
		const tag = tags?.find((item) => item.id === tagId)
		const tagColors = tag
			? { backgroundColor: hexToRGB(tag?.color_id, alpha), color: tag?.color_id }
			: { backgroundColor: "#DFE1E6", color: "#475163" }

		return tagColors
	}

	const getTagName = (tagId) => {
		const tag = tags?.find((item) => item.id === tagId)
		return tag?.name || null
	}

	const hexToRGB = (hex, alpha) => {
		let r = parseInt(hex.slice(1, 3), 16),
			g = parseInt(hex.slice(3, 5), 16),
			b = parseInt(hex.slice(5, 7), 16)

		if (alpha) {
			return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")"
		} else {
			return "rgb(" + r + ", " + g + ", " + b + ")"
		}
	}

	useEffect(() => {
		if (props?.fileData?.currTag?.[0]) {
			setSelectedTag(props?.fileData?.currTag?.[0])
		} else {
			setSelectedTag("")
		}
	}, [props?.fileData])

	return (
		<>
			<FormControl className={classes.formControl}>
				<Tooltip title={selectedTag ? getTagName(selectedTag) : t("tag.apply")} placement="top">
					<Select
						variant="standard"
						value={selectedTag}
						onChange={handleChange}
						displayEmpty
						className={classes.selectEmpty}
						style={{ ...getTagColor(selectedTag, 0.1) }}
						disableUnderline
						MenuProps={{
							anchorOrigin: {
								vertical: "bottom",
								horizontal: "left",
							},
							getContentAnchorEl: null,
							PaperProps: {
								style: {
									//maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
									width: "250px",
									overflowX: "scroll",
								},
							},
						}}
						IconComponent={KeyboardArrowDown}
						disabled={isReviewFormOpen}
					>
						<MenuItem value="" disabled className={classes.menuItemStyle}>
							{t("tag.apply")}
						</MenuItem>
						<MenuItem className={classes.menuItemStyle} value="remove">
							{t("tag.remove")}
						</MenuItem>
						{tags?.map((tag, index) => {
							return (
								<MenuItem
									className={classes.menuItemStyle}
									key={`taglist-${index}`}
									value={tag?.id}
									style={{ color: `${tag?.color_id}` }}
								>
									<Typography noWrap>{tag?.name}</Typography>
								</MenuItem>
							)
						})}
					</Select>
				</Tooltip>
			</FormControl>
		</>
	)
}
